import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../actions/Helper_action";
import { Search } from "react-feather";
import {
  Get_List_All_Rent_Contracts_Failed,
  Rent_Delete_Status,
  View_All_Rent_Contract,
} from "../../actions/Invoice_action";
import "./Loading.css";
import Swal from "sweetalert2";
import _ from "lodash";
import { Button, Drawer, Input, Tooltip } from "antd";
import { isMobile } from "react-device-detect";
import PropertyesList from "../../containers_Agent/Propertys_Agent/PropertyesList";
import View_AllRent from "./ViewContracts/View_AllRent";
const AllRentContract_Failed = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_All_Rent_Contracts_Failed());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const all_rent_contracts_failed = useSelector(
    (state) => state.InvoiceReducer.all_rent_contracts_failed
  );
  const R_status_failed = useSelector(
    (state) => state.InvoiceReducer.R_status_failed
  );
  const [visible, setvisible] = useState(false);
  const onClose = () => {
    setvisible(false);
  };
  const showDrawer = () => {
    setvisible(true);
  };
  const [search, setsearch] = useState("");
  const [select_property, setselect_property] = useState("");
  const onDeleteRent_Contract = (id, status) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Rent_Delete_Status(id, status));
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
          timer: 1000,
        });
      }
    });
  };
  const handleChange_Property = (value) => {
    setselect_property(value);
  };
  const RentContractList_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const datas = all_rent_contracts_failed
    .filter((data) => {
      if (isNaN(search)) {
        if (
          data.tenantId &&
          data.tenantId.secondname
            .toLowerCase()
            .startsWith(search.toLowerCase())
        ) {
          return (
            data.tenantId &&
            data.tenantId.secondname
              .toLowerCase()
              .startsWith(search.toLowerCase())
          );
        } else if (
          data.firstname.toLowerCase().startsWith(search.toLowerCase())
        ) {
          return data.firstname.toLowerCase().startsWith(search.toLowerCase());
        } else if (
          data.available_id &&
          data.available_id.NOoFProperty.toString().startsWith(search)
        ) {
          return (
            data.available_id &&
            data.available_id.NOoFProperty.toString().startsWith(search)
          );
        }
      } else if (select_property === "Apartment") {
        return data.available_id && data.available_id.Property === "Apartment";
      } else if (select_property === "House") {
        return data.available_id && data.available_id.Property === "House";
      } else if (select_property === "Farm") {
        return data.available_id && data.available_id.Property === "Farm";
      } else if (select_property === "Shop") {
        return data.available_id && data.available_id.Property === "Shop";
      } else if (select_property === "Vella") {
        return data.available_id && data.available_id.Property === "Vella";
      } else if (select_property === "Earth") {
        return data.available_id && data.available_id.Property === "Earth";
      } else if (select_property === "The gas station") {
        return (
          data.available_id && data.available_id.Property === "The gas station"
        );
      } else if (select_property === "Factory") {
        return data.available_id && data.available_id.Property === "Factory";
      } else if (select_property === "GYM") {
        return data.available_id && data.available_id.Property === "GYM";
      } else if (select_property === "store") {
        return data.available_id && data.available_id.Property === "store";
      } else if (select_property === "Restaurant") {
        return data.available_id && data.available_id.Property === "Restaurant";
      } else if (select_property === "Commercial Land") {
        return (
          data.available_id && data.available_id.Property === "Commercial Land"
        );
      } else if (select_property === "Company") {
        return data.available_id && data.available_id.Property === "Company";
      } else if (select_property === "Hotel") {
        return data.available_id && data.available_id.Property === "Hotel";
      } else if (select_property === "Car Garage") {
        return data.available_id && data.available_id.Property === "Car Garage";
      } else if (select_property === "Stadium") {
        return data.available_id && data.available_id.Property === "Stadium";
      } else if (select_property === "Car wash") {
        return data.available_id && data.available_id.Property === "Car wash";
      } else if (select_property === "Building") {
        return data.available_id && data.available_id.Property === "Building";
      } else if (select_property === "Agitator") {
        return data.available_id && data.available_id.Property === "Agitator";
      } else if (select_property === "Strecture") {
        return data.available_id && data.available_id.Property === "Strecture";
      } else if (select_property === "residential community") {
        return (
          data.available_id &&
          data.available_id.Property === "residential community"
        );
      } else if (select_property === "agricultural land of the register") {
        return (
          data.available_id &&
          data.available_id.Property === "agricultural land of the register"
        );
      } else if (select_property === "unregistered agricultural land") {
        return (
          data.available_id &&
          data.available_id.Property === "unregistered agricultural land"
        );
      } else if (select_property === "Government agricultural land") {
        return (
          data.available_id &&
          data.available_id.Property === "Government agricultural land"
        );
      } else if (select_property === "Land of Istamar") {
        return (
          data.available_id && data.available_id.Property === "Land of Istamar"
        );
      } else if (select_property === "Erth Musataha") {
        return (
          data.available_id && data.available_id.Property === "Erth Musataha"
        );
      } else if (select_property === "school") {
        return data.available_id && data.available_id.Property === "school";
      } else if (select_property === "Building of Istamar") {
        return (
          data.available_id &&
          data.available_id.Property === "Building of Istamar"
        );
      } else if (select_property === "Building of Musataha") {
        return (
          data.available_id &&
          data.available_id.Property === "Building of Musataha"
        );
      } else {
        if (
          data.paymentmonth &&
          data.paymentmonth.toString().startsWith(search)
        ) {
          return (
            data.paymentmonth && data.paymentmonth.toString().startsWith(search)
          );
        } else if (
          data.available_id &&
          data.available_id.NOoFProperty.toString().startsWith(search)
        ) {
          return (
            data.available_id &&
            data.available_id.NOoFProperty.toString().startsWith(search)
          );
        } else {
          return data.InvoiceNO && data.InvoiceNO.toString().startsWith(search);
        }
      }
    })
    .map((el, i) => {
      return {
        id: el.InvoiceNO,
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => {
                  dispatch(View_All_Rent_Contract(el._id, el.InvoiceNO));
                  showDrawer();
                }}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => onDeleteRent_Contract(el._id, "delete")}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-ban text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
          </>
        ),
        branchId: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.branchId && el.branchId.name}
          </span>
        ),
        firstName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.firstname}</span>
        ),
        secondName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.tenantId && el.tenantId.secondname}
          </span>
        ),
        Area: <span className={`${lang === "en" ? "" : "fk"}`}>{el.Area}</span>,
        branchId: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.branchId && el.branchId.name}
          </span>
        ),
        phone: el.Phone,
        lastPrice: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.paymentmonth}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix={`${el.currency !== "dolar" ? "ID" : "$"}`}
          />
        ),
        property_detail: (
          <>
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id &&
                dispatch(change_Lang(el.available_id.Property))}
            </span>
            &nbsp;-&nbsp;
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id && el.available_id.NOoFProperty}
            </span>
          </>
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "id",
      sortable: true,
      center: true,
      compact: true,
      width: "80px",
    },
    {
      name: dispatch(change_Lang("Name of Branch")),
      selector: "branchId",
      center: true,
      compact: true,
      width: "110px",
    },
    {
      name: dispatch(change_Lang("Property Detail")),
      selector: "property_detail",
      center: true,
      compact: true,
      width: "200px",
    },
    {
      name: dispatch(change_Lang("property owner")),
      selector: "firstName",
      center: true,
      compact: true,
      width: "180px",
    },
    {
      name: dispatch(change_Lang("tenant")),
      selector: "secondName",
      center: true,
      compact: true,
      width: "260px",
    },
    {
      name: dispatch(change_Lang("pr_price")),
      selector: "lastPrice",
      center: true,
      compact: true,
      width: "130px",
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
      width: "130px",
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const Total_Property_Price_Dolar = _.sumBy(
    all_rent_contracts_failed,
    function (o) {
      if (o.status !== "delete" && select_property) {
        if (
          (o.available_id && o.available_id.Property) === select_property &&
          o.currency !== "dinar"
        ) {
          return Number(o.paymentmonth);
        } else {
          return 0;
        }
      } else {
        if (o.currency !== "dinar") {
          return Number(o.paymentmonth);
        } else {
          return 0;
        }
      }
    }
  );
  const Total_Property_Price_Dinar = _.sumBy(
    all_rent_contracts_failed,
    function (o) {
      if (o.status !== "delete" && select_property) {
        if (
          (o.available_id && o.available_id.Property) === select_property &&
          o.currency !== "dolar"
        ) {
          return Number(o.paymentmonth);
        } else {
          return 0;
        }
      } else {
        if (o.currency !== "dolar") {
          return Number(o.paymentmonth);
        } else {
          return 0;
        }
      }
    }
  );
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Fast rental contracts"))}
          parent={dispatch(change_Lang("Contract List"))}
        />
        {R_status_failed !== true ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-12 ">
                  <div>
                    <div className="row ">
                      <div
                        className={
                          isMobile
                            ? "col-md-3 d-flex justify-content-center"
                            : "col-md-3 d-flex justify-content-start"
                        }
                      >
                        <PropertyesList
                          onChangeProperty={handleChange_Property}
                          valueOption={select_property}
                          className="fk text-center"
                          size="middle"
                          showSearch
                          optionFilterProp="children"
                          filterOption={true}
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#052f43",
                            width: "200px",
                          }}
                          showArrow={false}
                        />
                        {/* &nbsp;{" "}
                        <Link
                          onClick={RentContractList_getPrint}
                          to={`/Print_all_contractRent/${
                            select_property ? select_property : "all"
                          }`}
                        >
                          <Button
                            title={dispatch(change_Lang("Print"))}
                            style={{
                              background: "#efefed",
                              color: "#295a68",
                              border: "none",
                            }}
                            icon={
                              <i className="fa fa-print" aria-hidden="true"></i>
                            }
                          />
                        </Link> */}
                      </div>
                      <div className={isMobile ? "col-md-6" : "col-md-6"}>
                        <div className=" text-center mt-2">
                          <h3 style={{ fontWeight: "bold", color: "#295a68" }}>
                            {dispatch(change_Lang("Fast rental contracts"))}
                          </h3>
                        </div>
                      </div>
                      <div className="col-md-3 m-auto">
                        <div className="form-group form-inline d-flex justify-content-center">
                          <Input
                            type="text"
                            name="search"
                            value={search}
                            onChange={(e) => setsearch(e.target.value)}
                            size="middle"
                            placeholder={dispatch(change_Lang("Search"))}
                            autoComplete="off"
                            className="ml-2"
                            style={{ width: "180px" }}
                            prefix={<Search color="lightgray" />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="user-status table-responsive latest-order-table">
                      <DataTable
                        columns={columns}
                        className={`${lang === "en" ? "" : "fk"}`}
                        customStyles={customStyles}
                        data={datas}
                        pagination={true}
                        striped
                        noDataComponent={dispatch(change_Lang("table_display"))}
                      />
                    </div>
                    <br />
                    <div class="container">
                      <ul class="responsive-table">
                        <li class="table-header">
                          <div class="col d-flex justify-content-center">
                            <span style={{ fontSize: "16px" }}>
                              {" "}
                              کۆی گشتی پارەی (
                              {`${
                                select_property !== ""
                                  ? dispatch(change_Lang(select_property))
                                  : dispatch(change_Lang("All properties"))
                              }`}
                              )
                            </span>
                          </div>
                        </li>
                        <td></td>
                        <li class="table-row">
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Payment Status"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Property_Price_Dolar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Payment Status"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Property_Price_Dinar}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="IQD"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Drawer onClose={onClose} open={visible} width="950px">
              <View_AllRent onClose={onClose} />
            </Drawer>
          </>
        )}
      </Fragment>
    </>
  );
};

export default AllRentContract_Failed;
